import React from 'react'
import classNames from 'classnames'

import styles from './styles'

const TableLoadingAnimation = () => {
  const classes = styles()
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
        <div
          className={classNames(
            classes.skeleton,
            classes.skeletonText,
            classes.skeletonTextBody,
          )}
        ></div>
      </div>
    </div>
  )
}

export default TableLoadingAnimation
